import React from 'react';
import PropTypes from 'prop-types';

const GenerateBarberShortLink = ({ barber, wrapperClass, generateShortLink }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">Short link</div>
    <div display-if={barber.shortLink}>
      <a href={barber.shortLink} target="_blank" rel="noopener noreferrer">{barber.shortLink}</a>
    </div>
    <div display-if={!barber.shortLink}>
      <button
        type="button"
        onClick={generateShortLink}
        className="c-btn c-btn--small"
      >Generate short link</button>
    </div>
  </div>
);

GenerateBarberShortLink.propTypes = {
  barber: PropTypes.object,
  wrapperClass: PropTypes.string,
  generateShortLink: PropTypes.func.isRequired,
};

GenerateBarberShortLink.defaultProps = {
  barber: {},
  wrapperClass: '',
};

export default GenerateBarberShortLink;
